// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Site } from "./Site";
import { SiteFromJSON, SiteFromJSONTyped, SiteToJSON, SiteToJSONTyped } from "./Site";
import type { Options } from "./Options";
import {
  OptionsFromJSON,
  OptionsFromJSONTyped,
  OptionsToJSON,
  OptionsToJSONTyped,
} from "./Options";
import type { Filter } from "./Filter";
import { FilterFromJSON, FilterFromJSONTyped, FilterToJSON, FilterToJSONTyped } from "./Filter";
import type { Content } from "./Content";
import {
  ContentFromJSON,
  ContentFromJSONTyped,
  ContentToJSON,
  ContentToJSONTyped,
} from "./Content";

/**
 *
 * @export
 * @interface CatalogHarvester
 */
export interface CatalogHarvester {
  /**
   *
   */
  id: number;
  /**
   *
   */
  type: string;
  /**
   *
   */
  site: Site;
  /**
   *
   */
  options: Options;
  /**
   *
   */
  filters: Array<Filter>;
  /**
   *
   */
  content?: Content | null;
}

/**
 * Check if a given object implements the CatalogHarvester interface.
 */
export function instanceOfCatalogHarvester(value: object): value is CatalogHarvester {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("site" in value) || value["site"] === undefined) return false;
  if (!("options" in value) || value["options"] === undefined) return false;
  if (!("filters" in value) || value["filters"] === undefined) return false;
  return true;
}

export function CatalogHarvesterFromJSON(json: any): CatalogHarvester {
  return CatalogHarvesterFromJSONTyped(json, false);
}

export function CatalogHarvesterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CatalogHarvester {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    type: json["type"],
    site: SiteFromJSON(json["site"]),
    options: OptionsFromJSON(json["options"]),
    filters: (json["filters"] as Array<any>).map(FilterFromJSON),
    content:
      json["content"] === undefined
        ? undefined
        : json["content"] === null
        ? null
        : ContentFromJSON(json["content"]),
  };
}

export function CatalogHarvesterToJSON(json: any): CatalogHarvester {
  return CatalogHarvesterToJSONTyped(json, false);
}

export function CatalogHarvesterToJSONTyped(
  value?: CatalogHarvester | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    type: value["type"],
    site: SiteToJSON(value["site"]),
    options: OptionsToJSON(value["options"]),
    filters: (value["filters"] as Array<any>).map(FilterToJSON),
    content: ContentToJSON(value["content"]),
  };
}
